import * as _ from 'lodash'

export class Allocator {

    sumTotal: number = 0;

    valueDct: { [id: string]: number } = {};
    resultDct: {[id:string]: number} = {};

    bHasChanged: boolean = true;

    add(key: string, value: number) {
        let dctKey = key.toString();
        if (_.isUndefined(this.valueDct[dctKey])) {
            this.valueDct[dctKey] = 0;
        }
        this.valueDct[dctKey] += value;
        this.sumTotal += value;
        this.bHasChanged = true;
    }

    addMultiple(dct: {[id: string] : number}) {
        _.forEach(_.keys(dct), (aKey: string) => {
            this.add(aKey, dct[aKey]);
        })
    }

    getPercent(key: string) {
        if (this.sumTotal != 0 && this.bHasChanged) {

            let unAllocatedAmt: number = 1;
            const self = this;
            _.forEach(_.keys(this.valueDct), (dctKey) => {
                self.resultDct[dctKey] = self.valueDct[dctKey] / self.sumTotal;
                unAllocatedAmt -= self.resultDct[dctKey];
            });

            if (unAllocatedAmt != 0) {
                let nSmallestVal: number = self.resultDct[key];
                let nLargestVal: number = self.resultDct[key];
                let smallestValKey: string;
                let largestValKey: string;

                _.forEach(_.keys(self.resultDct), (aKey) => {
                    if (self.resultDct[aKey] >= nLargestVal) {
                        nLargestVal = self.resultDct[aKey];
                        largestValKey = aKey;
                    }
                    if (self.resultDct[aKey] <= nSmallestVal) {
                        nSmallestVal = self.resultDct[aKey];
                        smallestValKey = aKey;
                    }
                });

                if (unAllocatedAmt < 0) {
                    self.resultDct[largestValKey] += unAllocatedAmt;
                }
                if (unAllocatedAmt > 0) {
                    self.resultDct[smallestValKey] += unAllocatedAmt;
                }
            }

            this.bHasChanged = false;
            return this.resultDct[key];

        } else if (this.sumTotal != 0) {
            return this.resultDct[key];
        } else {
            return 0;
        }
    }

    getKeys() : string[] {
        return _.keys(this.valueDct)
    }
}